import { render, staticRenderFns } from "./CloudSync.vue?vue&type=template&id=df970f92&scoped=true&"
import script from "./CloudSync.vue?vue&type=script&lang=js&"
export * from "./CloudSync.vue?vue&type=script&lang=js&"
import style0 from "./CloudSync.vue?vue&type=style&index=0&id=df970f92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df970f92",
  null
  
)

export default component.exports